// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3PKZv","buttons":"PendingPaymentAlert_buttons__1OUYm"};